// src/components/card/CardProgress.jsx
import React from 'react';
import { SAFE, DESIGN_W } from './layout';

/**
 * mode:
 *  - 'bar'   : 連續型（原本的藍色條，給集點用）
 *  - 'steps' : 步進型（細線 + 圓點，給等級用）
 */
export default function CardProgress({
  px,
  current = 0,
  max = 20,
  y,
  mode = 'bar',
  colors = { done: '#5e3a1a', remain: '#c28b4e' },
  dotColor = '#fff',
  thickness = 18,    // 線條粗細（設計稿 px）
  dotSize = 25,     // 圓點直徑（設計稿 px）
}) {
  const top  = px((y ?? 0) - 5);
  const left = px(SAFE*1.25);
  const w    = px(DESIGN_W - SAFE * 2.5);

  if (mode === 'steps') {
    const steps = Math.max(2, max || 2);
    const idx   = Math.max(1, Math.min(steps, Math.round(current || 1))); // 1..steps
    const doneP = (idx - 1) / (steps - 1); // 0..1（對齊到該圓點）

    const lineH = px(thickness);
    const d     = px(dotSize);

    return (
      <div style={{ position:'absolute', left, top, width:w, height: Math.max(d, lineH), zIndex:2 }}>
        {/* 未完成段 */}
        <div style={{
          position:'absolute', left:0, right:0, top:'50%',
          height: lineH, background: colors.remain, borderRadius: 999,
          transform:'translateY(-50%)'
        }}/>
        {/* 已完成段 */}
        <div style={{
          position:'absolute', left:0, width: `${doneP * 100}%`, top:'50%',
          height: lineH, background: colors.done, borderRadius: 999,
          transform:'translateY(-50%)'
        }}/>

        {/* 圓點（每個等級一顆） */}
        {Array.from({ length: steps }).map((_, i) => (
          <div
            key={i}
            style={{
              position:'absolute',
              left: `${(i / (steps - 1)) * 100}%`,
              top:'50%',
              width:d, height:d, borderRadius:'50%',
              background: dotColor,
              border: `1px solid ${i <= (idx - 1) ? colors.done : colors.remain}`,
              transform:'translate(-50%, -50%)',
              boxShadow:'0 1px 2px rgba(0,0,0,.15)'
            }}
          />
        ))}
      </div>
    );
  }

  // 連續型（原本集點條）
  const pct = Math.max(0, Math.min(1, current / (max || 1)));
  return (
    <div style={{
      position:'absolute',left:left- SAFE *0.25/2, top,
      width:w+SAFE *0.25, height:px(17),
      background:'#fff', borderRadius:px(999), overflow:'hidden',
      boxShadow:'0 0 0 1px rgba(0,0,0,.06) inset',
      zIndex:2,
    }}>
      <div style={{
        width:`${pct * 100}%`, height:'100%',
        background:'linear-gradient(90deg,#5de0e6,#004aad)'
      }}/>
    </div>
  );
}
